import { Component, EventEmitter, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatCard, MatCardModule } from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from 'src/app/core/services/AuthService/auth.service';

@Component({
  selector: 'app-profile-edit',
  standalone: true,
  templateUrl: './profile-edit.component.html',
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatCard,
    MatCardModule,
    MatIcon,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
  ],
})
export class ProfileEditComponent {
  @Output() logoutEvent = new EventEmitter<void>();
  
  profileForm!: FormGroup;
  imagePreview!: string;
  username: string = '';
  email: string = '';

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public dialogRef: MatDialogRef<ProfileEditComponent>
  ) {}

  async ngOnInit() {
    const user = await this.authService.getUser();
    if (user) {
      this.email = user.email;
      const userProfile = await this.authService.getUserProfile(user.email);
      this.username = userProfile.firstName || 'Usuário';
    }
  }

  // Processa o envio do formulário
  onSubmit() {
    if (this.profileForm.valid) {
      // Processar dados do formulário (ex: enviar para backend)
      console.log(this.profileForm.value);
      this.dialogRef.close(); // Fechar o modal após salvar
    } else {
      console.log('Form is invalid');
    }
  }

  logout(): void {
    this.authService.logout();
    this.dialogRef.close();
  }

  // Função que lida com input de arquivos
  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.profileForm.patchValue({
        profileImage: file,
      });
      this.previewImage(file); // Pré-visualizar a imagem selecionada
    }
  }

  openAccountSettings() {
    // Primeiro, fechar o dialog e depois navegar
    this.dialogRef.close(); // Fecha o dialog

    // Navega para a tela de configurações de conta
    this.router.navigate(['/account-settings']);
  }

  // Função para pré-visualizar a imagem
  previewImage(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };
  }
}
